import { useSyncExternalStore } from "react";
import { DataTable } from "@carbon6/c6-frontend-design";
import { probeColumns } from "../probeColumns";
import type { ProbeTableSource } from "../ProbeTableSource";
import styles from "./ProbeSection.module.css";

type ProbeHistoryTableProps = {
  source: ProbeTableSource;
  /** 지금 아래 카드가 보여 주는 Probe. 선택(selection)이 아니라 current 축이다. */
  currentProbeUuid: string | null;
};

/**
 * Probe 이력 표.
 *
 * 행을 고르면 아래 상세가 바뀐다 — c6 가 selection 과 current 를 독립 축으로 분리해 둔 계약을
 * 그대로 쓴다(고른 것을 대상으로 하는 일괄 명령이 없어 selection 축은 비운다).
 */
export function ProbeHistoryTable({ currentProbeUuid, source }: ProbeHistoryTableProps) {
  const snapshot = useSyncExternalStore(source.subscribe, source.getSnapshot);

  if (snapshot.total <= 1) {
    // 한 건뿐이면 표가 아무것도 고르게 해 주지 않는다 — 아래 카드가 그 건을 이미 말한다.
    return null;
  }

  return (
    <div className={styles.history}>
      <DataTable
        scrollable
        appearance="framed"
        ariaLabel="Probe 이력"
        columns={probeColumns}
        currentRowId={currentProbeUuid}
        emptyMessage="아직 요청한 Probe 가 없습니다."
        loadingMessage="Probe 이력을 불러오고 있습니다."
        minWidth="720px"
        showCurrentMarker
        source={source}
      />
    </div>
  );
}
